import { FC } from 'react';

// all icons use a 24×24 viewBox, stroke="currentColor", fill="none".
const svgProps = { strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, strokeWidth: '2' };

const Svg: FC<{ children: React.ReactNode }> = ({ children }) => (
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
    {children}
  </svg>
);

export const HomeIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
    />
  </Svg>
);

export const LibraryIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
  </Svg>
);

export const CustomPageIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
    />
  </Svg>
);

export const PerformanceIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
  </Svg>
);

export const TrashIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </Svg>
);

export const SupportIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </Svg>
);

export const ChevronRightIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M9 5l7 7-7 7" />
  </Svg>
);

export const ChevronLeftIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M15 19l-7-7 7-7" />
  </Svg>
);

export const CloseIcon: FC = () => (
  <Svg>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
  </Svg>
);

export const AdminStudioIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path {...svgProps} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </Svg>
);

export const CompanyAssetsIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
    />
  </Svg>
);

export const PersonIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </Svg>
);

export const GroupIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
    />
  </Svg>
);

export const TagIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
    />
  </Svg>
);

export const DocumentIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </Svg>
);

export const DatabaseIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
    />
  </Svg>
);

export const LayersIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
  </Svg>
);

export const BarChartIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
    />
  </Svg>
);

export const ConfigIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
    />
  </Svg>
);

export const ChartIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
    />
  </Svg>
);

export const SearchIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
  </Svg>
);

export const PlusIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M12 4v16m8-8H4" />
  </Svg>
);

export const PinIcon: FC<{ filled?: boolean }> = ({ filled }) => (
  <svg fill={filled ? 'currentColor' : 'none'} stroke="currentColor" viewBox="0 0 24 24">
    <path {...svgProps} d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z" />
  </svg>
);

export const ProjectIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    />
  </Svg>
);

export const WorkspaceIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path {...svgProps} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </Svg>
);

export const SlideLibraryIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
  </Svg>
);

export const FolderIcon: FC = () => (
  <Svg>
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
  </Svg>
);

export const SlideIcon: FC = () => (
  <Svg>
    <path
      {...svgProps}
      d="M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"
    />
  </Svg>
);

export const GlobeIcon: FC = () => (
  <Svg>
    <circle cx="12" cy="12" r="9" strokeWidth="1.8" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M12 3c-4 4-4 14 0 18M12 3c4 4 4 14 0 18M3 12h18" />
  </Svg>
);

export const LinkIcon: FC = () => (
  <Svg>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.8"
      d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
    />
  </Svg>
);

export const LockIcon: FC = () => (
  <Svg>
    <rect x="5" y="11" width="14" height="10" rx="2" strokeWidth="1.8" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M8 11V7a4 4 0 118 0v4" />
  </Svg>
);

export const CheckCircleIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </Svg>
);

export const WarningIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
  </Svg>
);

export const ChevronDownIcon: FC = () => (
  <Svg>
    <path {...svgProps} d="M6 9l6 6 6-6" />
  </Svg>
);

export const DeckIcon: FC = () => (
  <svg viewBox="0 0 22 22" fill="none" stroke="currentColor" strokeWidth="1.6">
    <rect x="5" y="7" width="14" height="10" rx="1.5" />
    <rect x="3" y="5" width="14" height="10" rx="1.5" fill="white" />
    <rect x="1" y="3" width="14" height="10" rx="1.5" fill="white" />
    <rect x="3" y="6" width="6" height="4" rx="0.8" />
    <line x1="11" y1="8" x2="14" y2="8" />
    <line x1="11" y1="10.5" x2="14" y2="10.5" />
  </svg>
);

export const PageDocumentIcon: FC = () => (
  <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
  </svg>
);

export const SlideStatusDot: FC<{ filled?: boolean }> = ({ filled = true }) => (
  <svg width="10" height="10" viewBox="0 0 12 12" style={{ flexShrink: 0 }} overflow="visible">
    {filled ? (
      <circle cx="6" cy="6" r="6" fill="currentColor" />
    ) : (
      <circle cx="6" cy="6" r="6" fill="none" stroke="currentColor" strokeWidth="1.5" />
    )}
  </svg>
);
